module.exports = __webpack_public_path__ + "img/image_030.2fc3d15c.jpg";